import { render, staticRenderFns } from "./IconOtp.vue?vue&type=template&id=2b4442f2&"
import script from "./IconOtp.vue?vue&type=script&lang=js&"
export * from "./IconOtp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports